export default "__VITE_ASSET__ie3rbc4o__"